import classNames from 'classnames/bind';
import { element, func, bool, string, oneOfType, object } from 'prop-types';
import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';

import s from './index.module.css';
import Button from '../Button';
import { CloseIcon } from '../Icons';

import { usePortal } from '../../utils';

const cx = classNames.bind(s);

const TRANSITION_DELAY = 100;

const Modal = (props) => {
  const {
    children,
    onClose,
    withOverlay,
    className,
    wrapperClassName,
    closeConfig,
    showClose,
    isPortal,
    overlayClassName,
    overlayClick = () => setFadeType('out'),
  } = props;
  const [fadeType, setFadeType] = useState('out');
  const target = usePortal('modal-root');

  useEffect(() => {
    let fadeInTimeout = setTimeout(() => setFadeType('in'), TRANSITION_DELAY);

    return () => {
      clearTimeout(fadeInTimeout);
    };
  }, []);

  const transitionEnd = () => {
    if (fadeType === 'in') return;

    if (fadeType === 'out') {
      onClose();
    }
  };

  const onCrossClick = () => {
    setFadeType('out');
    onClose();
  };

  const handleCrossMouseDown = (e) => {
    e.preventDefault();
    onClose();
  };

  const modalUI = (
    <div
      className={cx(s.modalWrapper, { modalWrapper_out: fadeType === 'out', [wrapperClassName]: !!wrapperClassName })}
      onTransitionEnd={transitionEnd}
    >
      {withOverlay && (
        <div className={cx(s.modalOverlay, { [overlayClassName]: overlayClassName })} onClick={overlayClick} />
      )}

      <div className={cx(s.modalBody, { [className]: true })}>
        <Button
          className={cx(s.close, { [closeConfig.className]: closeConfig.className, close_hide: !showClose })}
          onClick={onCrossClick}
          onMouseDown={handleCrossMouseDown}
        >
          <CloseIcon color={closeConfig.color} width={closeConfig.width || 16} height={closeConfig.height || 16} />
        </Button>
        {children}
      </div>
    </div>
  );

  return isPortal ? ReactDOM.createPortal(modalUI, target) : modalUI;
};

Modal.propTypes = {
  isPortal: bool,
  showClose: bool,
  withOverlay: bool,
  onClose: func,
  overlayClick: func,
  children: oneOfType([string, element]),
  className: string,
  wrapperClassName: string,
  closeConfig: object,
  overlayClassName: string,
};

Modal.defaultProps = {
  isPortal: true,
  showClose: true,
  withOverlay: true,
  onClose: () => {},
  children: null,
  className: undefined,
  wrapperClassName: undefined,
  closeConfig: {},
  overlayClassName: undefined,
};

export default Modal;
